module.exports = __webpack_public_path__ + "img/item_color.12a379c4.jpg";